var $ = jQuery;

jQuery(document).ready(function ($) {

    class Education {

        init() {
            this.initQrTargets();
            this.initStandardsRegion();
            this.initJoinClass();
            this.initInviteTeacher();
            this.initMakeOwner();
            this.initCopyJoinCode();
            this.initRenameClass();
            this.initModalNav();
            this.initGradeFilter();
            this.initAssignCourse();
            this.initRemoveCourse();
            this.initProgressModal();
            this.initTableDropdowns();
            this.initCreateClass();
            this.initAddStudents();
            this.initTeacherSignup();
            this.initSetupWizard();
            this.initDistrict();
            this.initLeaveSchool();
            this.initJoinSchool();
            this.initSchoolInvites();
            this.initFeedback();
        }

        initQrTargets() {
            if (typeof QRCode === "undefined") {
                return;
            }
            $(".qrTarget").each(function () {
                var size = $(this).data("size") || 110;
                new QRCode(this, { text: $(this).data("url"), width: size, height: size });
            });
        }

        post(action, fields, success, messageElement) {
            var formData = new FormData();
            formData.append("action", action);
            formData.append("educationNonce", educationData.educationNonce);
            Object.keys(fields).forEach(function (key) {
                formData.append(key, fields[key]);
            });
            var ajaxForm = new AjaxForm(formData);
            ajaxForm.call(function (data) {
                if (data.success) {
                    success(data.message);
                    return;
                }
                if (messageElement) {
                    messageElement.text(data.message);
                }
            });
        }

        initJoinClass() {
            var _this = this;
            $(document).on("show.bs.modal", "#joinClassModal", function () {
                $("#dailyRewardModal").modal("hide");
            });
            $("#joinClassInput").on("input", function () {
                this.value = this.value.toUpperCase();
            });
            $(document).on("click", "#joinClassButton", function () {
                _this.post("joinClassroom", { joinCode: $("#joinClassInput").val(), firstName: $("#joinClassName").val() }, function (message) {
                    var body = $("#joinClassModal .modal-body").empty();
                    var success = $("<div class='text-center py-3'>");
                    success.append($("<h4 class='font-weight-bold mb-2'>").text("Welcome to " + message.className + "!"));
                    if (message.courseUrl) {
                        success.append($("<div class='text-secondary mb-3'>").text("Your teacher picked your first course. Ready?"));
                        success.append($("<a class='btn btn-primary btn-lg rounded-pill font-weight-bold px-5'>").attr("href", message.courseUrl).text("Start " + message.courseTitle));
                    }
                    if (!message.courseUrl) {
                        success.append($("<div class='text-secondary mb-3'>").text("You are in. Your courses will show up on the Learn page."));
                        success.append($("<a class='btn btn-primary btn-lg rounded-pill font-weight-bold px-5' href='/learn'>").text("Let's go"));
                    }
                    body.append(success);
                    $("#joinClassButton").remove();
                    $("#joinClassModal").one("hidden.bs.modal", function () {
                        location.reload();
                    });
                }, $("#joinClassMessage"));
            });
        }

        initInviteTeacher() {
            var _this = this;
            $(document).on("click", "#inviteTeacherButton", function () {
                _this.post("inviteTeacher", { classroomId: $(this).data("classroom-id"), email: $("#inviteTeacherEmail").val().trim() }, function () {
                    location.reload();
                }, $("#inviteTeacherMessage"));
            });
        }

        initMakeOwner() {
            var _this = this;
            $(document).on("click", ".makeOwner", function () {
                _this.post("makeClassOwner", { classroomId: $(this).data("classroom-id"), teacherId: $(this).data("teacher-id") }, function () {
                    location.reload();
                });
            });
            $(document).on("click", ".removeCoTeacher", function () {
                _this.post("removeCoTeacher", { classroomId: $(this).data("classroom-id"), teacherId: $(this).data("teacher-id") }, function () {
                    location.reload();
                });
            });
            $(document).on("click", ".leaveClassroom", function () {
                _this.post("removeCoTeacher", { classroomId: $(this).data("classroom-id"), teacherId: $(this).data("teacher-id") }, function (message) {
                    window.location.href = message.url;
                });
            });
            $(document).on("click", ".makeSchoolOwner", function () {
                _this.post("setSchoolOwner", { schoolId: $(this).data("school-id"), userId: $(this).data("user-id") }, function () {
                    location.reload();
                });
            });
        }

        initCopyJoinCode() {
            $(document).on("click", ".copyJoinCode", function () {
                var icon = $(this);
                navigator.clipboard.writeText(icon.siblings(".joinCodeValue").text().trim());
                icon.removeClass("fa-copy").addClass("fa-check text-success");
                setTimeout(function () {
                    icon.removeClass("fa-check text-success").addClass("fa-copy");
                }, 1200);
            });
        }

        initGradeFilter() {
            var bands = { "all": [-99, 99], "k-2": [-1, 2], "3-5": [3, 5], "6-8": [6, 8], "9-12": [9, 12] };
            $(document).on("click", ".gradeBand", function () {
                var host = $(this).closest(".modal, .modalSections");
                var key = $(this).data("band");
                var band = bands[key];
                host.find(".gradeBand").removeClass("bg-lilac border-primary text-primary").addClass("bg-white");
                $(this).removeClass("bg-white").addClass("bg-lilac border-primary text-primary");
                host.find(".modalNav").each(function () {
                    var min = $(this).data("min");
                    var max = $(this).data("max");
                    var fits = key === "all" || min === "" || (max >= band[0] && min <= band[1]);
                    $(this).toggleClass("d-none", !fits).toggleClass("d-flex", fits);
                });
                host.find(".modalGroup").each(function () {
                    $(this).toggleClass("d-lg-block", $(this).nextUntil(".modalGroup", ".modalNav:not(.d-none)").length > 0);
                });
                host.find(".modalNav:not(.d-none)").first().trigger("click");
            });
        }

        initModalNav() {
            var _this = this;
            $(document).on("click", ".modalNav", function () {
                var nav = $(this);
                var modal = nav.closest(".modal, .modalSections");
                modal.find(".modalNav").removeClass("bg-lilac font-weight-bold");
                nav.addClass("bg-lilac font-weight-bold");
                modal.find(".modalPane").addClass("d-none");
                var pane = modal.find(".modalPane[data-pane='" + nav.data("pane") + "']").removeClass("d-none");
                pane.closest(".col-lg-9").scrollTop(0);
                if (!nav.data("course-id") || pane.data("loaded")) {
                    return;
                }
                _this.post("coursePane", { courseId: nav.data("course-id"), classroomId: nav.data("classroom-id") }, function (message) {
                    pane.html(message.html).data("loaded", true);
                });
            });
            $(".modalSections .modalNav.bg-lilac").trigger("click");
            $(document).on("shown.bs.modal", ".modal", function () {
                $(this).find(".modalNav.bg-lilac[data-course-id]").trigger("click");
                var panes = $(this).find(".modalPane");
                if (!panes.length || panes.first().data("course-id")) {
                    return;
                }
                var tallest = 0;
                panes.each(function () {
                    var pane = $(this);
                    var hidden = pane.hasClass("d-none");
                    pane.removeClass("d-none").css("visibility", "hidden");
                    tallest = Math.max(tallest, pane.outerHeight());
                    pane.css("visibility", "").toggleClass("d-none", hidden);
                });
                panes.css("min-height", tallest + "px");
            });
        }

        initRenameClass() {
            var _this = this;
            var input = $("#classroomName");
            var saved = input.val();
            $(document).on("click", ".editTypePill", function () {
                $(".editTypePill").removeClass("active iconSelected").css("opacity", "0.4");
                $(this).addClass("active iconSelected").css("opacity", "");
            });
            var settings = function (button) {
                return {
                    classroomId: button.data("classroom-id"),
                    className: $("#editClassName").val(),
                    classPublicName: $("#editClassPublicName").val(),
                    classGrade: $("#editClassGrade").val(),
                    classIcon: $(".editTypePill.active").data("icon") || "",
                    studentOrder: $("input[name=studentOrder]:checked").val(),
                    hideLastNames: $("input[name=hideLastNames]:checked").val()
                };
            };
            $(document).on("click", ".classroomIconOption", function () {
                var button = $(this);
                _this.post("updateClassroomIcon", { classroomId: button.data("classroom-id"), classIcon: button.data("icon") }, function (message) {
                    $("#classroomIcon").css("background-color", button.data("color")).find("i").attr("class", "fas " + message.icon + " fa-lg");
                    $(".classroomIconOption").removeClass("iconSelected").css("opacity", "0.4");
                    button.addClass("iconSelected").css("opacity", "");
                });
            });
            $(document).on("click", "#saveClassInfo, #saveClassDisplay", function () {
                _this.post("updateClassroomSettings", settings($(this)), function () {
                    location.reload();
                }, $(".editClassMessage"));
            });
            $(document).on("change", ".assistantSwitch", function () {
                $(this).next("label").text(this.checked ? "On" : "Off");
            });
            $(document).on("change", "#classAssistantSwitch", function () {
                _this.post("setClassroomAssistant", { classroomId: $(this).data("classroom-id"), enabled: this.checked ? 1 : 0 }, function () {}, $(".editClassMessage"));
            });
            $(document).on("click", ".archiveClassButton", function () {
                _this.post("archiveClassroom", { classroomId: $(this).data("classroom-id"), archived: $(this).data("archived") }, function () {
                    location.reload();
                }, $(".editClassMessage"));
            });
            input.on("focus", function () {
                input.removeClass("form-control-plaintext").addClass("form-control");
            });
            input.on("input", function () {
                input.attr("size", Math.max(8, input.val().length));
            });
            input.on("keydown", function (event) {
                if (event.key === "Enter") {
                    input.blur();
                }
                if (event.key === "Escape") {
                    input.val(saved).blur();
                }
            });
            input.on("blur", function () {
                input.removeClass("form-control").addClass("form-control-plaintext");
                var name = input.val().trim();
                if (name === "" || name === saved) {
                    input.val(saved).attr("size", Math.max(8, saved.length));
                    return;
                }
                _this.post("renameClassroom", { classroomId: input.data("classroom-id"), className: name }, function () {
                    document.title = document.title.replace(saved, name);
                    saved = name;
                }, null);
            });
        }

        initAssignCourse() {
            var _this = this;
            $(document).on("click", ".assignCourseButton", function () {
                _this.post("assignCourseToClassroom", {
                    classroomId: $(this).data("classroom-id"),
                    courseId: $(this).data("course-id")
                }, function () {
                    location.reload();
                }, $("#assignCourseMessage"));
            });
        }

        initTableDropdowns() {
            $(document).on("shown.bs.dropdown", ".table-responsive-md .dropdown", function () {
                var wrapper = $(this).closest(".table-responsive-md");
                if (wrapper.css("overflow-x") !== "auto") {
                    return;
                }
                wrapper.css("padding-bottom", $(this).find(".dropdown-menu").outerHeight());
            });
            $(document).on("hidden.bs.dropdown", ".table-responsive-md .dropdown", function () {
                $(this).closest(".table-responsive-md").css("padding-bottom", "");
            });
        }

        initProgressModal() {
            var _this = this;
            var cell = null;
            var render = function (stars, started) {
                if (stars === 3) {
                    return "<i class='fas fa-check-circle fa-lg text-success'></i>";
                }
                if (stars > 0) {
                    return "<span class='text-nowrap text-warning font-weight-bold'><i class='fas fa-star small mr-1'></i>" + stars + "</span>";
                }
                if (started) {
                    return "<i class='fas fa-pen text-warning'></i>";
                }
                return "<i class='far fa-circle text-muted'></i>";
            };
            var earnedHtml = function (earned) {
                if (earned === "") {
                    return "<span class='text-secondary h6 mb-0'>Not submitted yet</span>";
                }
                var html = "";
                for (var i = 0; i < 3; i++) {
                    html += "<i class='fas fa-star " + (i < Number(earned) ? "text-warning" : "text-light") + "'></i>";
                }
                return html;
            };
            var showOverride = function (override) {
                var on = override !== "";
                $("#progressOverrideSwitch").prop("checked", on).next("label").text(on ? "On" : "Off");
                $("#progressStarPicker").toggleClass("d-none", !on);
                $(".progressStar").removeClass("starSelected btn-primary").addClass("btn-outline-secondary");
                if (on) {
                    $(".progressStar[data-stars='" + override + "']").removeClass("btn-outline-secondary").addClass("starSelected btn-primary");
                }
            };
            var save = function (override) {
                _this.post("setStudentStars", { classroomId: $("#classroomName").data("classroom-id"), studentId: cell.data("student-id"), puzzleId: cell.data("puzzle-id"), stars: override }, function (message) {
                    var row = cell.closest("tr");
                    var total = 0;
                    cell.attr("data-stars", message.stars).data("stars", message.stars).attr("data-override", override).html(render(message.stars, Number(cell.attr("data-started")) === 1));
                    row.find(".openProgress").each(function () { total += Number($(this).data("stars")); });
                    row.find("td:last .font-weight-bold").text(total + "/" + row.find(".openProgress").length * 3);
                    showOverride(override === "" ? "" : String(override));
                }, $("#progressMessage"));
            };
            $(document).on("click", ".openProgress", function () {
                cell = $(this);
                var started = Number(cell.attr("data-started")) === 1;
                $("#progressModalTitle").text(cell.data("student-name"));
                $("#progressModalAvatar").text(String(cell.data("student-name")).charAt(0).toUpperCase());
                $("#progressChallenge").text("Challenge " + cell.data("number") + ": " + cell.data("puzzle-title"));
                $("#progressEarned").html(earnedHtml(cell.attr("data-earned")));
                showOverride(cell.attr("data-override"));
                $("#progressMessage").empty();
                $("#progressOpenProject").attr("href", cell.data("project-url"));
                $("#progressStartedBox").toggleClass("d-none", !started);
                $("#progressNotStarted").toggleClass("d-none", started);
                $("#progressModal .modalNav[data-pane=stars]").trigger("click");
            });
            $(document).on("change", "#progressOverrideSwitch", function () {
                if (this.checked) {
                    save(Number(cell.attr("data-earned")) || 0);
                    return;
                }
                save("");
            });
            $(document).on("click", ".progressStar", function () {
                var stars = $(this).data("stars");
                if (String(stars) === cell.attr("data-override")) {
                    return;
                }
                save(stars);
            });
        }

        initRemoveCourse() {
            var _this = this;
            var panes = {};
            $(document).on("click", ".removeCourseOption", function () {
                var option = $(this);
                var pane = $("#courseSettingsModal .courseSettingsPane");
                $("#courseSettingsModalTitle").text(option.data("course-title"));
                $("#removeCourseName").text(option.data("course-title"));
                $("#removeCourseButton").data("course-id", option.data("course-id"));
                $("#courseSettingsModal .modalNav[data-pane=course]").trigger("click");
                if (panes[option.data("course-id")]) {
                    pane.html(panes[option.data("course-id")]);
                    return;
                }
                pane.html("<div class='text-center py-5'><i class='fas fa-circle-notch fa-spin fa-2x text-secondary'></i></div>");
                _this.post("coursePane", { courseId: option.data("course-id"), classroomId: $("#classroomName").data("classroom-id"), assigned: 1 }, function (message) {
                    panes[option.data("course-id")] = message.html;
                    pane.html(message.html);
                });
            });
            $(document).on("click", "#removeCourseButton", function () {
                _this.post("removeCourseFromClassroom", {
                    classroomId: $(this).data("classroom-id"),
                    courseId: $(this).data("course-id")
                }, function () {
                    location.reload();
                });
            });
        }

        initStandardsRegion() {
            var select = $("#standardsRegion");
            if (!select.length) {
                return;
            }
            var apply = function (region) {
                $(".regionStandards").addClass("d-none");
                if (region) {
                    $(".regionStandards[data-region='" + region + "']").removeClass("d-none");
                }
            };
            var saved = "";
            try {
                saved = localStorage.getItem("pixelpadStandardsRegion") || "";
            } catch (error) { }
            if (saved && select.find("option[value='" + saved + "']").length) {
                select.val(saved);
                apply(saved);
            }
            select.on("change", function () {
                apply(this.value);
                try {
                    localStorage.setItem("pixelpadStandardsRegion", this.value);
                } catch (error) { }
            });
        }

        initCreateClass() {
            var _this = this;
            $(document).on("click", ".newClassIcon", function () {
                $(".newClassIcon").removeClass("active iconSelected").css("opacity", "0.4");
                $(this).addClass("active iconSelected").css("opacity", "");
            });
            $(document).on("click", "#createClassSubmit", function () {
                _this.post("createClassroom", { className: $("#newClassName").val(), classGrade: $("#newClassGrade").val(), classIcon: $(".newClassIcon.active").data("icon"), schoolId: $("#schoolPage").data("school-id") }, function (message) {
                    window.location.href = message.classroomUrl;
                }, $("#createClassMessage"));
            });
            $(document).on("keydown", "#newClassName", function (event) {
                if (event.key === "Enter") {
                    $("#createClassSubmit").click();
                }
            });
        }

        initAddStudents() {
            var _this = this;
            var reloadWithCount = function (count) {
                var url = new URL(window.location.href);
                url.searchParams.set("created", count);
                window.location.href = url.toString();
            };
            this.students = [];
            var parseName = function (line) {
                line = line.trim();
                if (line.indexOf(",") !== -1) {
                    var flipped = line.split(",");
                    return { first: flipped[1].trim(), last: flipped[0].trim() };
                }
                var parts = line.split(/\s+/);
                return { first: parts.shift() || "", last: parts.join(" ") };
            };
            var parseSpreadsheetRow = function (line) {
                var cells = line.split(/\t|\s{2,}|,|;/).map(function (cell) { return cell.trim().replace(/^"|"$/g, ""); });
                return { first: cells[0] || "", last: cells[1] || "" };
            };
            var withoutDuplicates = function (students) {
                var seen = {};
                return students.filter(function (student) {
                    var key = (student.first + "|" + student.last).toLowerCase();
                    if (seen[key]) {
                        return false;
                    }
                    seen[key] = true;
                    return true;
                });
            };
            var renderConfirm = function () {
                var rows = $("#asConfirmRows").empty();
                _this.students.forEach(function (student, index) {
                    var row = $("<tr>");
                    row.append($("<td>").append($("<input type='text' class='form-control form-control-sm asFirst'>").attr("data-index", index).val(student.first)));
                    row.append($("<td>").append($("<input type='text' class='form-control form-control-sm asLast'>").attr("data-index", index).val(student.last)));
                    row.append($("<td class='align-middle text-center'>").append($("<i class='fas fa-times text-secondary hover-pointer asRemove'>").attr("data-index", index)));
                    rows.append(row);
                });
            };
            var showPaste = function () {
                $("#asConfirmView").addClass("d-none");
                $("#asPasteView").removeClass("d-none");
                $("#addStudentsMessage").text("");
            };
            var importMode = "word";
            $(document).on("click", ".asImportMode", function () {
                importMode = $(this).data("mode");
                $(".asImportMode").removeClass("btn-primary").addClass("bg-white text-primary");
                $(this).removeClass("bg-white text-primary").addClass("btn-primary");
                $("#asPasteInput").attr("placeholder", $("#asPasteInput").data("placeholder-" + importMode));
                $("#asCsvUpload").toggleClass("d-none", importMode !== "excel");
            });
            $(document).on("change", "#asCsvFile", function () {
                var input = this;
                var reader = new FileReader();
                reader.onload = function () {
                    $("#asPasteInput").val(reader.result);
                    input.value = "";
                };
                reader.readAsText(input.files[0]);
            });
            $(document).on("click", "#asImportList", function () {
                var lines = $("#asPasteInput").val().split("\n").map(function (line) { return line.trim(); }).filter(Boolean);
                if (!lines.length) {
                    $("#addStudentsMessage").text("Paste at least one name first.");
                    return;
                }
                $("#addStudentsMessage").text("");
                if (importMode === "excel" && /^(first|last|student|name)/i.test(lines[0])) {
                    lines.shift();
                }
                _this.students = withoutDuplicates(lines.map(importMode === "excel" ? parseSpreadsheetRow : parseName));
                renderConfirm();
                $("#asPasteView").addClass("d-none");
                $("#asConfirmView").removeClass("d-none");
            });
            $(document).on("click", ".asRemove", function () {
                _this.students.splice(Number($(this).attr("data-index")), 1);
                renderConfirm();
            });
            $(document).on("input", ".asFirst, .asLast", function () {
                var index = Number($(this).attr("data-index"));
                _this.students[index][$(this).hasClass("asFirst") ? "first" : "last"] = this.value;
            });
            $(document).on("click", "#asFlipNames", function () {
                _this.students = _this.students.map(function (student) {
                    return { first: student.last, last: student.first };
                });
                renderConfirm();
            });
            $(document).on("click", "#asConfirmBack", function () {
                $("#asPasteInput").val(_this.students.map(function (student) {
                    return [student.first, student.last].filter(Boolean).join(importMode === "excel" ? "\t" : " ");
                }).join("\n"));
                showPaste();
            });
            $(document).on("hidden.bs.modal", "#addStudentsModal", function () {
                _this.students = [];
                $("#asPasteInput, #asPassword").val("");
                $("#asPasswordBox").removeClass("show");
                showPaste();
            });
            $(document).on("click", "#addStudentsButton", function () {
                var button = $(this);
                var students = _this.students.filter(function (student) {
                    return (student.first + student.last).trim() !== "";
                });
                if (!students.length) {
                    $("#addStudentsMessage").text("Type a student's name first.");
                    return;
                }
                _this.post("bulkAddStudents", {
                    classroomId: button.data("classroom-id"),
                    students: JSON.stringify(students),
                    password: $("#asPassword").val()
                }, function (message) {
                    reloadWithCount(message.students.length);
                }, $("#addStudentsMessage"));
            });
            $(document).on("click", ".openStudent", function () {
                var button = $(this);
                var ownPassword = button.data("own-password") === 1;
                var initial = String(button.data("name")).charAt(0).toUpperCase();
                $("#studentModalTitle").text(button.data("name"));
                $("#studentModalAvatar, #studentAvatarLarge").text(initial);
                $("#studentStars").text(button.data("stars") + " stars");
                $("#studentUsername").text(button.data("username"));
                $("#studentPassword").text(ownPassword ? "Chosen by the student" : (String(button.data("password") || "") || "Reset to see it"));
                $("#studentResetPassword").data("student-id", button.data("student-id")).data("classroom-id", button.data("classroom-id")).toggleClass("d-none", ownPassword);
                $(".copyStudentField[data-field=studentPassword]").toggleClass("d-none", ownPassword || !button.data("password"));
                $("#studentCardName").text(button.data("name"));
                $("#studentCardUsername").text(button.data("username"));
                $("#studentCardPassword").text(ownPassword ? "their own (signs in with email)" : (String(button.data("password") || "") || "reset it above to see it"));
                $("#studentFirst").val(button.data("first"));
                $("#studentLast").val(button.data("last"));
                $("#studentModalMessage").empty();
                $("#studentSaveProfile").data("student-id", button.data("student-id"));
                $("#studentRemove").data("student-id", button.data("student-id"));
                $("#studentPreview").data("student-id", button.data("student-id")).data("classroom-id", button.data("classroom-id"));
                $(".studentAssignments").addClass("d-none").filter("[data-student-id='" + button.data("student-id") + "']").removeClass("d-none");
                $("#studentModal .modalNav[data-pane=profile]").trigger("click");
            });
            $(document).on("click", ".copyStudentField", function () {
                var button = $(this);
                navigator.clipboard.writeText($("#" + button.data("field")).text());
                button.text("Copied");
                setTimeout(function () { button.text("Copy"); }, 1200);
            });
            $(document).on("click", "#studentResetPassword", function () {
                var button = $(this);
                _this.post("resetStudentPassword", { classroomId: button.data("classroom-id"), studentId: button.data("student-id") }, function (message) {
                    $("#studentPassword, #studentCardPassword").text(message.password);
                    $(".copyStudentField[data-field=studentPassword]").removeClass("d-none");
                    $(".openStudent[data-student-id='" + message.studentId + "']").attr("data-password", message.password).data("password", message.password);
                    _this.loginCards = null;
                }, $("#studentModalMessage"));
            });
            $(document).on("click", "#studentTransfer", function () {
                var button = $(this);
                _this.post("transferStudent", { classroomId: button.data("classroom-id"), studentId: $("#studentSaveProfile").data("student-id"), targetId: $("#studentTransferTarget").val() }, function () {
                    location.reload();
                }, $("#studentModalMessage"));
            });
            $(document).on("click", "#studentSaveProfile", function () {
                var button = $(this);
                _this.post("updateStudentProfile", { classroomId: button.data("classroom-id"), studentId: button.data("student-id"), first: $("#studentFirst").val(), last: $("#studentLast").val() }, function () {
                    location.reload();
                }, $("#studentModalMessage"));
            });
            $(document).on("click", "#studentPreview", function () {
                var button = $(this);
                _this.post("switchToStudent", { classroomId: button.data("classroom-id"), studentId: button.data("student-id") }, function (message) {
                    window.location.href = message.url;
                }, $("#studentModalMessage"));
            });
            $(document).on("click", "#switchBack", function () {
                _this.post("switchBack", {}, function (message) {
                    window.location.href = message.url;
                });
            });
            $(document).on("click", "#studentRemove", function () {
                $("#removeStudentName").text($("#studentModalTitle").text());
                $("#removeStudentButton").data("student-id", $(this).data("student-id"));
                $("#studentModal").one("hidden.bs.modal", function () {
                    $("#removeStudentModal").modal("show");
                }).modal("hide");
            });
            $(document).on("click", "#removeStudentButton", function () {
                _this.post("removeStudent", { classroomId: $(this).data("classroom-id"), studentId: $(this).data("student-id") }, function () {
                    location.reload();
                }, $("#removeStudentMessage"));
            });
            var downloadCards = function (fields, layout, status) {
                if (status && _this.loginCards) {
                    _this.saveLoginPdf(_this.loginCards, layout);
                    status.removeClass("d-none");
                    return;
                }
                _this.post("printLoginCards", fields, function (message) {
                    _this.saveLoginPdf(message, layout);
                    if (status) {
                        _this.loginCards = message;
                        status.removeClass("d-none");
                    }
                });
            };
            $(document).on("click", ".openFamilyLayout", function () {
                $("input[name=loginLayout][value=poster]").prop("checked", true);
                $("#loginOptionsModal .modalNav[data-pane=cards]").trigger("click");
            });
            $(document).on("hidden.bs.modal", "#loginOptionsModal", function () {
                $("#downloadStatus").addClass("d-none");
            });
            $(document).on("change", "input[name=loginLayout]", function () {
                $("#downloadStatus").addClass("d-none");
            });
            $(document).on("click", "#downloadFamilySheets", function () {
                downloadCards({ classroomId: $(this).data("classroom-id") }, "family", $("#familySheetsStatus"));
            });
            $(document).on("click", "#downloadCards", function () {
                downloadCards({ classroomId: $(this).data("classroom-id") }, $("input[name=loginLayout]:checked").val(), $("#downloadStatus"));
            });
        }

        saveLoginPdf(message, layout) {
            var doc = new window.jspdf.jsPDF({ unit: "mm", format: "letter" });
            var passwordText = function (card) {
                if (card.password) {
                    return card.password;
                }
                return "their own (signs in with email)";
            };
            if (layout === "family") {
                message.cards.forEach(function (card, index) {
                    if (index > 0) {
                        doc.addPage();
                    }
                    doc.setFont("helvetica", "bold").setFontSize(14).text("PixelPAD", 20, 22);
                    doc.setFontSize(26).text("Join our class!", 20, 42);
                    doc.setFont("helvetica", "normal").setFontSize(14).text(message.className, 20, 51);
                    doc.setFontSize(11).text("For " + card.name + "'s family", 20, 62);
                    doc.text(doc.splitTextToSize("This year our class is learning to code on PixelPad. " + card.name.split(" ")[0] + " can keep building at home with the login below. - " + message.teacherName, 170), 20, 72);
                    doc.setDrawColor(60).setLineWidth(0.8).roundedRect(20, 90, 176, 72, 4, 4);
                    doc.setFont("helvetica", "bold").setFontSize(12).text("Website", 28, 102);
                    doc.setFont("helvetica", "normal").text(message.host, 70, 102);
                    doc.setFont("helvetica", "bold").text("Username", 28, 114);
                    doc.setFont("helvetica", "normal").text(card.username, 70, 114);
                    doc.setFont("helvetica", "bold").text("Password", 28, 126);
                    doc.setFont("helvetica", "normal").text(passwordText(card), 70, 126);
                    doc.setFontSize(11);
                    doc.text("1. Go to " + message.host + " on the device your child uses at home.", 28, 140);
                    doc.text("2. Click Login and type the username and password above.", 28, 148);
                    doc.text("3. Everything built in class is there to keep building.", 28, 156);
                });
            } else if (layout === "poster") {
                doc.setFont("helvetica", "bold").setFontSize(14).text("PixelPAD", 20, 22);
                doc.setFontSize(24).text("3 steps to set up student logins", 20, 42);
                var steps = [
                    ["Print it", "Print one login poster per student."],
                    ["Share it", "Send the posters home with students, or tape each one to their desk for class."],
                    ["Log in", "Students go to " + message.host + ", click Login, and type the username and password on their poster."]
                ];
                steps.forEach(function (step, index) {
                    var top = 60 + index * 26;
                    doc.setFont("helvetica", "bold").setFontSize(14).text((index + 1) + ".  " + step[0], 20, top);
                    doc.setFont("helvetica", "normal").setFontSize(12).text(doc.splitTextToSize(step[1], 160), 31, top + 8);
                });
                message.cards.forEach(function (card) {
                    doc.addPage();
                    doc.setFont("helvetica", "bold").setFontSize(14).text("PixelPAD", 20, 22);
                    doc.setFontSize(18).text(card.name + "'s Login Poster", 196, 22, { align: "right" });
                    doc.setDrawColor(60).setLineWidth(0.8).roundedRect(38, 40, 140, 70, 6, 6);
                    doc.setFontSize(13).text("Username", 108, 58, { align: "center" });
                    doc.setFontSize(26).text(card.username, 108, 72, { align: "center" });
                    doc.setFontSize(13).text("Password", 108, 88, { align: "center" });
                    doc.setFontSize(26).text(passwordText(card), 108, 102, { align: "center" });
                    doc.setFontSize(14).text("Instructions:", 20, 130);
                    var boxes = ["Go to " + message.host + " from a computer.", "Click Login.", "Type your username and password from above."];
                    boxes.forEach(function (text, index) {
                        var x = 20 + index * 60;
                        doc.setDrawColor(150).setLineWidth(0.5).roundedRect(x, 138, 56, 60, 5, 5);
                        doc.setFillColor(40).circle(x + 28, 152, 6, "F");
                        doc.setTextColor(255).setFont("helvetica", "bold").setFontSize(12).text(String(index + 1), x + 28, 154, { align: "center" });
                        doc.setTextColor(0).setFont("helvetica", "normal").setFontSize(11).text(doc.splitTextToSize(text, 48), x + 28, 172, { align: "center" });
                    });
                });
            } else {
                doc.setFont("helvetica", "bold").setFontSize(14).text(message.className, 15, 15);
                message.cards.forEach(function (card, index) {
                    var slot = index % 8;
                    if (index > 0 && slot === 0) {
                        doc.addPage();
                        doc.setFont("helvetica", "bold").setFontSize(14).text(message.className, 15, 15);
                    }
                    var x = 15 + (slot % 2) * 95;
                    var y = 22 + Math.floor(slot / 2) * 54;
                    doc.setDrawColor(150).setLineDashPattern([1.5, 1.5], 0).roundedRect(x, y, 88, 46, 3, 3);
                    doc.setFont("helvetica", "normal").setFontSize(9);
                    doc.setFont("helvetica", "bold").text(card.name, x + 5, y + 8);
                    doc.setFont("helvetica", "normal");
                    var stepOne = doc.splitTextToSize("1.) Go to " + message.host + " and click the 'Login' button", 78);
                    doc.text(stepOne, x + 5, y + 16);
                    var cursor = y + 16 + (stepOne.length - 1) * 4;
                    doc.text("2.) Type in your username: " + card.username, x + 5, cursor + 7);
                    doc.text("3.) Type in your password: " + passwordText(card), x + 5, cursor + 14);
                    doc.text("4.) Click the login button.", x + 5, cursor + 21);
                });
            }
            doc.save(message.className + " logins.pdf");
        }

        initFeedback() {
            var _this = this;
            $(document).on("click", ".feedbackSend", function () {
                var button = $(this);
                var pane = button.closest(".modalPane");
                var message = pane.find(".feedbackMessage").val().trim();
                pane.find(".feedbackError").empty();
                if (message === "") {
                    return;
                }
                var where = button.data("modal-id") + ": " + $("#" + button.data("modal-id") + "Title").text().trim();
                _this.post("educationFeedback", { message: message, where: where, url: location.href, browser: navigator.userAgent + " | " + screen.width + "x" + screen.height + " | " + navigator.language }, function () {
                    pane.find(".feedbackEcho").text(message);
                    pane.find(".feedbackForm").addClass("d-none");
                    pane.find(".feedbackDone").removeClass("d-none");
                }, pane.find(".feedbackError"));
            });
            $(document).on("hidden.bs.modal", ".modal", function () {
                $(this).find(".feedbackForm").removeClass("d-none");
                $(this).find(".feedbackDone").addClass("d-none");
                $(this).find(".feedbackMessage").val("");
            });
        }

        initLeaveSchool() {
            var _this = this;
            $(document).on("click", "#leaveSchoolSubmit", function () {
                _this.post("leaveSchool", { schoolId: $(this).data("school-id"), handoffId: $("#leaveSchoolHandoff").val() }, function (message) {
                    window.location.href = message.url;
                }, $("#leaveSchoolMessage"));
            });
        }

        initJoinSchool() {
            var _this = this;
            $(document).on("click", ".fillInviteEmail", function () {
                $("#signup_username, #signup_username_teacher, #login_username").val($(this).data("email"));
            });
            $(document).on("click", "#joinSchoolSubmit", function () {
                _this.post("joinSchool", { schoolId: $(this).data("school-id"), token: $(this).data("token") }, function (message) {
                    window.location.href = message.url;
                }, $("#joinSchoolMessage"));
            });
        }

        initSchoolInvites() {
            var _this = this;
            $(document).on("click", ".resendInvite", function () {
                var status = $(this).closest(".inviteRow").find(".inviteStatus");
                _this.post("resendSchoolInvite", { schoolId: $(this).data("school-id"), token: $(this).data("token") }, function (message) {
                    status.text(message);
                }, status);
            });
            $(document).on("click", ".cancelInvite", function () {
                _this.post("cancelSchoolInvite", { schoolId: $(this).data("school-id"), token: $(this).data("token") }, function () {
                    _this.refreshStaff();
                }, $(this).closest(".inviteRow").find(".inviteStatus"));
            });
        }

        refreshStaff() {
            if (!$("#districtStaff").length) {
                location.reload();
                return;
            }
            $("#districtStaff").data("loaded", false);
            $(".districtTab[data-pane='districtStaff']").trigger("click");
        }

        initDistrict() {
            var _this = this;
            $(document).on("click", ".districtTab", function () {
                $(".districtTab").removeClass("border-primary text-primary").addClass("border-white text-secondary");
                $(this).removeClass("border-white text-secondary").addClass("border-primary text-primary");
                $(".districtPane").addClass("d-none");
                var pane = $("#" + $(this).data("pane")).removeClass("d-none");
                if (pane.attr("id") !== "districtStaff" || pane.data("loaded")) {
                    return;
                }
                _this.post("districtStaff", { districtId: $("#districtPage").data("district-id") }, function (message) {
                    pane.removeClass("text-center py-5").html(message.html).data("loaded", true);
                });
            });
            $(document).on("click", "#createSchoolSubmit", function () {
                _this.post("createSchool", { districtId: $("#districtPage").data("district-id"), schoolName: $("#newSchoolName").val().trim() }, function () {
                    location.reload();
                }, $("#createSchoolMessage"));
            });
            $(document).on("click", "#inviteStaffSubmit", function () {
                _this.post("inviteStaff", { schoolId: $("#inviteStaffSchool").val(), email: $("#inviteStaffEmail").val().trim() }, function () {
                    $("#inviteStaffModal").modal("hide");
                    $("#inviteStaffEmail").val("");
                    _this.refreshStaff();
                }, $("#inviteStaffMessage"));
            });
            $(document).on("change", ".staffManagerSwitch", function () {
                var input = $(this);
                _this.post("setStaffManager", { schoolId: input.data("school-id"), userId: input.data("user-id"), manager: this.checked ? 1 : 0 }, function () {
                    input.closest(".rounded-xl").find(".staffRole").text(input.is(":checked") ? input.data("on") : input.data("off"));
                });
            });
            $(document).on("click", ".removeStaffOption", function () {
                var option = $(this);
                $("#removeStaffName").text(option.data("name"));
                $("#removeStaffSubmit").data("school-id", option.data("school-id")).data("user-id", option.data("user-id"));
                $("#removeStaffHandoff option").each(function () {
                    var handoff = $(this);
                    handoff.prop("hidden", handoff.val() !== "0" && (handoff.data("school-id") !== option.data("school-id") || handoff.val() == option.data("user-id")));
                }).first().prop("selected", true);
            });
            $(document).on("click", "#removeStaffSubmit", function () {
                _this.post("removeStaff", { schoolId: $(this).data("school-id"), userId: $(this).data("user-id"), handoffId: $("#removeStaffHandoff").val() }, function () {
                    location.reload();
                }, $("#removeStaffMessage"));
            });
            var fillingSchool = false;
            $(document).on("click", ".openSchool", function () {
                var row = $(this);
                fillingSchool = true;
                $("#schoolModal").data("school-id", row.data("school-id"));
                $("#schoolModalTitle").text(row.data("name"));
                $("#schoolName").val(row.data("name"));
                $("#schoolAssistant").prop("checked", row.data("assistant") === 1).trigger("change");
                $("input[name=schoolOrder][value='" + row.data("order") + "']").prop("checked", true);
                $("input[name=schoolHideLastNames][value='" + row.data("hide-last-names") + "']").prop("checked", true);
                $("#schoolProfileMessage, #schoolSettingsMessage").empty();
                $("#schoolModal .modalNav[data-pane=profile]").trigger("click");
                fillingSchool = false;
            });
            var schoolRow = function () {
                return $(".openSchool[data-school-id='" + $("#schoolModal").data("school-id") + "']");
            };
            $(document).on("blur", "#schoolName", function () {
                var name = $(this).val().trim();
                if (name === "" || name === $("#schoolModalTitle").text()) {
                    $(this).val($("#schoolModalTitle").text());
                    return;
                }
                _this.post("renameSchool", { schoolId: $("#schoolModal").data("school-id"), schoolName: name }, function () {
                    schoolRow().attr("data-name", name).data("name", name).closest(".rounded-xl").find("a.h5").text(name);
                    $("#schoolModalTitle, #schoolPage h1").text(name);
                }, $("#schoolProfileMessage"));
            });
            $(document).on("keydown", "#schoolName", function (event) {
                if (event.key === "Enter") {
                    $(this).blur();
                }
            });
            $(document).on("change", "#schoolAssistant, input[name=schoolOrder], input[name=schoolHideLastNames]", function () {
                if (fillingSchool) {
                    return;
                }
                var fields = { schoolId: $("#schoolModal").data("school-id"), assistant: $("#schoolAssistant").is(":checked") ? 1 : 0, studentOrder: $("input[name=schoolOrder]:checked").val(), hideLastNames: $("input[name=schoolHideLastNames]:checked").val() };
                _this.post("updateSchoolSettings", fields, function () {
                    schoolRow().attr("data-assistant", fields.assistant).data("assistant", fields.assistant).attr("data-order", fields.studentOrder).data("order", fields.studentOrder).attr("data-hide-last-names", fields.hideLastNames).data("hide-last-names", Number(fields.hideLastNames));
                }, $("#schoolSettingsMessage"));
            });
        }

        initSetupWizard() {
            var _this = this;
            var wizard = $("#setupWizard");
            if (!wizard.length) {
                return;
            }
            var steps = ["#wizClass", "#wizCourses"];
            var current = 0;
            var showStep = function (index) {
                current = index;
                steps.forEach(function (selector, stepIndex) {
                    $(selector).toggleClass("d-none", stepIndex !== index);
                });
                $("#wizCourses").toggleClass("d-flex", index === 1);
                $("#wizBack").toggleClass("d-none", index === 0);
                $("#wizMessage").text("");
                $("#wizPane").toggleClass("col-lg-6", index === 0).toggleClass("col-lg-12", index > 0);
                $("#wizArt").toggleClass("d-lg-flex", index === 0);
                $("#wizContinue").toggleClass("d-none", index === 1);
                if (index === 0 && !$("#wizClassName").val().trim()) {
                    var title = wizard.data("teacher-title") || "";
                    var last = wizard.data("teacher-last") || "";
                    var owner = (title + " " + last).trim();
                    if (owner !== "") {
                        $("#wizClassName").val(owner + "'s Class");
                    }
                }
            };
            var createClass = function (courseId) {
                var fields = {
                    schoolId: $("#schoolPage").data("school-id"),
                    className: $("#wizClassName").val(),
                    classGrade: $("#wizGrade").val(),
                    classIcon: "",
                    courseId: courseId
                };
                var create = function () {
                    _this.post("createClassroom", fields, function (message) {
                        window.location.href = message.classroomUrl + (courseId ? "?q=progress" : "");
                    }, $("#wizMessage"));
                };
                var schoolName = ($("#wizSchoolName").val() || "").trim();
                if (schoolName === "") {
                    create();
                    return;
                }
                _this.post("renameSchool", { schoolId: $("#schoolPage").data("school-id"), schoolName: schoolName }, create, $("#wizMessage"));
            };
            var bands = { "all": [-99, 99], "k-2": [-1, 2], "3-5": [3, 5], "6-8": [6, 8], "9-12": [9, 12] };
            $(document).on("click", ".wizAssignCourse", function () {
                createClass($(this).data("course-id"));
            });
            $(document).on("click", "#wizBack", function () {
                showStep(current - 1);
            });
            $(document).on("click", "#wizContinue", function () {
                if (current === 0) {
                    if (!$("#wizClassName").val().trim()) {
                        $("#wizMessage").text("Give your class a name.");
                        return;
                    }
                    showStep(1);
                    var grade = $("#wizGrade").find("option:selected").data("index");
                    var band = "all";
                    if (grade !== undefined) {
                        band = grade <= 2 ? "k-2" : grade <= 5 ? "3-5" : grade <= 8 ? "6-8" : grade === 99 ? "all" : "9-12";
                    }
                    $("#wizCourses .gradeBand[data-band='" + band + "']").trigger("click");
                    return;
                }
                createClass(0);
            });
            showStep(0);
        }

        initTeacherSignup() {
            var syncName = function () {
                var fullName = ($("#signup_first_teacher").val() + " " + $("#signup_last_teacher").val()).trim();
                $("#signup_school_name[type=hidden]").val(fullName === "" ? "" : fullName + "'s School");
            };
            var syncTitle = function () {
                var selectValue = $("#signup_title_select_teacher").val();
                if (selectValue === "Other") {
                    $("#signup_title_teacher").val($("#signup_title_other_teacher").val().trim());
                    return;
                }
                $("#signup_title_teacher").val(selectValue);
            };
            $(document).on("change", "#signup_title_select_teacher", function () {
                if ($(this).val() === "Other") {
                    $("#signup_title_other_group").removeClass("d-none");
                    $("#signup_title_other_teacher").focus();
                }
                if ($(this).val() !== "Other") {
                    $("#signup_title_other_group").addClass("d-none");
                    $("#signup_title_other_teacher").val("");
                }
                syncTitle();
            });
            $(document).on("input", "#signup_title_other_teacher", syncTitle);
            $(document).on("input", "#signup_first_teacher, #signup_last_teacher", syncName);
            document.addEventListener("submit", function (event) {
                if (event.target && event.target.id === "signup_modal_form_teacher") {
                    syncName();
                    syncTitle();
                }
            }, true);
            $(document).on("focus", "#signup_password_teacher", function () {
                $("#pwRules").slideDown(200);
            });
            $(document).on("input", "#signup_password_teacher", function () {
                var value = this.value;
                var rules = [
                    [value.length >= 8, "#pwRuleLength"],
                    [/[a-zA-Z]/.test(value), "#pwRuleAlpha"],
                    [/[0-9]|[^a-zA-Z0-9]/.test(value), "#pwRuleNumber"],
                ];
                rules.forEach(function (rule) {
                    $(rule[1]).toggleClass("text-success", rule[0]).toggleClass("text-secondary", !rule[0])
                        .find("i").toggleClass("fa-check", rule[0]).toggleClass("fa-minus", !rule[0]);
                });
            });
        }
    }

    if (typeof educationData !== "undefined") {
        new Education().init();
    }
});
